export function titleize(text) {
  if(text===undefined || text === null)
    text =""
    var loweredText = text.toLowerCase().replace('  ', ' ').replace('   ', ' ').replace('    ', ' ')
      .replace('     ', ' ').replace('      ', ' ').replace('       ', ' ');
    var words = loweredText.split(" ");
    for (var a = 0; a < words.length; a++) {
      var w = words[a];
      var firstLetter = w[0];
      if (w.length > 2) {
        w = firstLetter.toUpperCase() + w.slice(1);
      } else {
        w = firstLetter + w.slice(1);
      }

      words[a] = w;
    }
    return words.join(" ");
  }


  export function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }


    export const responseMessage = (msg) => {
    // window.location.href = "//localhost:5000/login";
    // console.log(msg)
    switch (msg) {
        case "Request failed with status code 400": return "Essa solicitação não é válida!";
        case "Request failed with status code 401": return "Usuário sem permissão para executar essa operação!";
        case "Request failed with status code 403": return "Operação não autorizada pelo servidor";
        case "Request failed with status code 404": return "Não foi possivel localizar o recurso solicitado!";
        case "Request failed with status code 405": return "Não permitido, verifique os dados e tente novamente!";
        case "Request failed with status code 406": return "Dados incorretos, verifique os dados e tente novamente!";
        case "Request failed with status code 407": return "Usuário não autenticado ou token inválido!";
        case "Request failed with status code 452": return "O tipo de venda não foi informado!";
        case "Request failed with status code 453": return "Número da mesa não informado!";
        case "Request failed with status code 454": return "Nenhum item adicionado ao pedido!";
        case "Request failed with status code 455": return "Número da venda não informada!";
        case "Request failed with status code 456": return "Número da venda e tipo não localizado!";
        case "Request failed with status code 457": return "Número da venda não localizada!"
        case "Request failed with status code 458": return "Já existe uma venda para essa mesa no banco de dados!"
        case "Request failed with status code 488": return "Usuário e/ou senha incorreta!";
        case "Request failed with status code 500": return "Erro de servidor!";
        case "Request failed with status code 501": return "Nenhum recurso foi implementado!";
        case "Request failed with status code 503": return "Erro ao processar sua solicitação no servidor. Tente novamente em instantes!";
        case "Request failed with status code 511": return "As autenticações de internet não são válidas";
        case "Request failed with status code 510": return "Existem débitos em aberto junto ao CRQ10/CE";
        case "Request failed with status code 512": return "Já existe um valor cadastrado!";
        case "Request failed with status code 513": return "Os pontos do programa de fidelidade não foram validados!";
        case "Request failed with status code 514": return "Os pontos do programa de fidelidade já foram aplicados."
        case "Request failed with status code 515": return "Cancelamento não pode ser efetuado, a mesa está em uso."
        case "Request failed with status code 516": return "Não foi encontrada nenhuma licença para a loja!";
        case "Request failed with status code 517": return "Não foi possível criar uma conta, tente novamente dentro de algumas horas!";
        case "Request failed with status code 518": return "Já existe uma estabelecimento cadastrado para esse e-mail!";
        case "Request failed with status code 519": return "Já existe um usuário cadastrado para esse e-mail!";
        case "Request failed with status code 520": return "Já existe um usuário e/ou estabelecimento utilizando esse e-mail!";

        default:
            return msg;

    }
}
